import useArchive from "@hooks/useArchive"
import Acceptance from "../components/Acceptance"

export default function useSalonAcceptancesArchive(acceptances?: Jury.Resources.Acceptance[]) {
    const archive = useArchive(acceptances)
    
    archive.useComponent(Acceptance)
    archive.usePagination(100, "photos")
    archive.useOptions({ idx: true })
    archive.useGrid({ columns: "4" })
    archive.useEmpty({
        heading: "No acceptances in this category.",
        description: `Please, wait until the acceptances are chosen.`
    })

    return archive
}